import React, { useContext, useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import { BASE_URL_API } from '../../References/url'
import AuthContext from '../../Store/auth-context'
import styles from './AllClientOrders.module.css'

const AllClientOrders = () => {

    const [allOrders, setAllOrders] = useState([])
    const authCtx = useContext(AuthContext)
    const [filteredData, setFilteredData] = useState([])
    const [searchKey, setSearchKey] = useState('')

    const getAllOrder = async () => {
        const getAllOrderResponse = await fetch(BASE_URL_API + "/getAllClientOrders",
            {
                method: 'POST',
                body: JSON.stringify({
                    token: authCtx.token,
                    clientIdentifier: authCtx.clientIdentifier
                })
            });

        if (!getAllOrderResponse.ok) {
            console.log("Something went wrong : Server Error")
        } else {
            const getAllOrderRespo = await getAllOrderResponse.json()
            if (getAllOrderRespo.status === "success") {
                setAllOrders(getAllOrderRespo?.response)
                setFilteredData(getAllOrderRespo?.response)
            } else {
                if (getAllOrderRespo.message === 'token Expired, please login again!') {
                    authCtx.logout()
                } else {
                    setAllOrders([])
                }
            }
            console.log(getAllOrderRespo)
        }
    }

    useEffect(() => {
        getAllOrder()
    }, [])




    const filterData = (data, searchKey) => {
        setFilteredData(data.filter(item =>
            Object.values(item).some(value =>
                value?.toString().toLowerCase().includes(searchKey.toLowerCase())
            )
        ))
    }

    useEffect(() => {
        filterData(allOrders, searchKey)
    }, [searchKey])

    return (
        <div>
            <div className={styles.mainWrapper}>
                <div>
                    <div className={styles.topWrapper}>
                        <div className={styles.statsTxt}>
                            All Orders
                        </div>
                        <div className={styles.searchInput}>
                            <input placeholder="Search for anything..." value={searchKey} onChange={(e) => setSearchKey(e.target.value)} />
                        </div>
                    </div>

                    <div className={styles.tableWrapper}>
                        <div className={styles.tableHeader}>
                            <div className={styles.sn}># Order No.</div>
                            <div className={styles.dateTime}>Date Time.</div>
                            <div className={styles.fullname}>User name</div>
                            <div className={styles.itemQuantity}>Qty.</div>
                            <div className={styles.points}>Amount</div>
                            <div className={styles.address}>Place of Supply</div>
                            <div className={styles.time}>Action</div>
                        </div>
                        <div className={styles.rowsWrapper}>
                            {filteredData?.map((item, index) => (
                                <div className={styles.eachRowWrapper} key={index}>
                                    <div className={styles.sn}>...{item?.orderIdentifier?.substr(20, item?.orderIdentifier?.length - 15)}</div>
                                    <div className={styles.dateTime}>
                                        <div className={styles.placedOn}>
                                        {item?.placedOn}
                                        </div>
                                    </div>
                                    <div className={styles.fullname}>{item?.userIdentifier}</div>
                                    <div className={styles.itemQuantity}>
                                        {item?.totalItems}
                                    </div>
                                    <div className={styles.points}>
                                        ₹{item?.productsTotal}
                                    </div>
                                    <div className={styles.address}>
                                        <div className={styles.fullAddress}>
                                        {item?.fullAddress}
                                        </div>
                                    </div>
                                    <div className={styles.time}>
                                        <Link to={`/client-orders/${item?.orderIdentifier}`}>View Details</Link>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>


                </div>
            </div>

        </div>
    )
}

export default AllClientOrders